import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function rema(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@rema/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@rema/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@rema/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@rema/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@rema/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@rema/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}